import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from './app/App';
import { FournisseurSession } from './app/SessionContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles.css';

const racine = document.getElementById('racine');
if (!racine) {
  throw new Error('Élément #racine absent de index.html');
}

createRoot(racine).render(
  <StrictMode>
    {/* Filet de dernier recours : une erreur de rendu affiche un message et un
        bouton de rechargement, jamais une page blanche. */}
    <ErrorBoundary>
      {/* La session vient du serveur (cookie HttpOnly) : aucun jeton dans le
          navigateur, donc rien à voler par un script injecté. */}
      <FournisseurSession>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FournisseurSession>
    </ErrorBoundary>
  </StrictMode>,
);
